import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const SEO = ({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  article = null 
}) => {
  const { language } = useLanguage();
  
  const siteName = 'AJ Code Labs';
  const defaultTitle = language === 'es' 
    ? 'AJ Code Labs | Desarrollo de Software, IA y Digitalización'
    : 'AJ Code Labs | Software Development, AI & Digitalization';
  const defaultDescription = language === 'es'
    ? 'Transformamos tu negocio con desarrollo de software a medida, implementación de inteligencia artificial y digitalización de procesos. Oficinas en Miami, Quito y Londres.'
    : 'We transform your business with custom software development, artificial intelligence implementation, and process digitalization. Offices in Miami, Quito, and London.';
  const defaultImage = 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200';
  const baseUrl = 'https://ajcodelabs.ai';

  const seo = {
    title: title ? `${title} | ${siteName}` : defaultTitle,
    description: description || defaultDescription,
    image: image || defaultImage,
    url: url ? `${baseUrl}${url}` : baseUrl,
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <html lang={language} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={language === 'es' ? 'es_ES' : 'en_US'} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      {/* Canonical URL */}
      <link rel="canonical" href={seo.url} />

      {/* Article specific tags */}
      {article && (
        <>
          <meta property="article:published_time" content={article.date} />
          <meta property="article:author" content={article.author} />
          <meta property="article:section" content={article.category} />
          {article.tags?.map((tag, index) => (
            <meta key={index} property="article:tag" content={tag} />
          ))}
        </>
      )}
    </Helmet>
  );
};

export default SEO;
